<div class="user-card" [class.user-card--compact]="compact()">
    <div class="user-card__avatar">
      <img *ngIf="user()?.personalData?.avatar" src="{{ user()?.personalData?.avatar }}" alt="User Avatar" />
      <span *ngIf="!user()?.personalData?.avatar">{{ user()?.personalData | initials }}</span>
    </div>
    <div class="user-card__info">
      <div class="user-card__name">{{ user()?.personalData?.firstName }} {{ user()?.personalData?.lastName }}</div>
      <div class="user-card__details">{{ 'app.header.kidsCounter' | translate: { counter: kidsCount()  } }}</div>
    </div>
  </div>